import type { HotspotMarkerModel } from "@lib/contentful/mappers/modules/hotspot/types";
import { Text } from "@ecco/ui/text";
import { Box } from "@ecco/ui/box";
import { Flex } from "@ecco/ui/flex";
import { Popover, PopoverBody, PopoverContent } from "@ecco/ui/popover";
import type { FC } from "react";
import type { MarkerComponentProps } from "react-image-marker";
import { MarkerTrigger } from "./MarkerTrigger";
import { styles } from "./styles";
import { calculateLeft, calculateTop, useMarkerPopover } from "./useMarkerPopover";

export type CustomMarkerProps = MarkerComponentProps & HotspotMarkerModel;

export const CustomMarker: FC<CustomMarkerProps> = (props: CustomMarkerProps) => {
    const { description, title, left, top } = props;
    const { isOpen, onOpen, onClose, onToggle, placement, placementY, popoverProps } =
        useMarkerPopover(top, left);

    return (
        <Popover {...popoverProps}>
            <MarkerTrigger isOpen={isOpen} onOpen={onOpen} onToggle={onToggle} zIndex={1} />
            {/* We need a wrapper with this zIndex value, because in the native implementation from Chakra they set Zindex to 10.  */}
            <Box zIndex={isOpen ? 2 : -1} position="absolute" w="100%" h="100%" left={0} top={0}>
                <PopoverContent
                    rootProps={{ style: { transform: "scale(0)" } }}
                    sx={styles.popoverContent}
                >
                    <PopoverBody p={[3, 3]}>
                        <Flex alignItems="flex-start" flexDirection={"column"} gap={1}>
                            {title && <Text sx={styles.popoverTitle}>{title}</Text>}
                            {description && (
                                <Text sx={styles.popoverDescription}>{description}</Text>
                            )}
                        </Flex>
                    </PopoverBody>
                    <Box
                        display={["none", "block"]}
                        onMouseLeave={onClose}
                        position={"absolute"}
                        height="175%"
                        width="100%"
                        top={calculateTop(placementY)}
                        left={calculateLeft(placement)}
                    ></Box>
                </PopoverContent>
            </Box>
        </Popover>
    );
};
